import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, TrendingUp, Shield, DollarSign } from 'lucide-react';
import { Logo } from '../components/Logo';
import { motion } from 'framer-motion';
export function Inversiones() {
  return <div className="min-h-screen bg-brand-black flex flex-col" data-id="element-566" data-mp="1hngnk6yaxfq7">
      <nav className="border-b border-brand-gold/20 p-6" data-id="element-567" data-mp="1mk72gqyde5a1">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-568" data-mp="1mmtk5jez615z">
          <Link to="/" data-id="element-569" data-mp="2abcrnwq7a9x0">
            <Logo data-id="element-570" data-mp="2acxe0z2d2mjs" />
          </Link>
          <Link to="/" className="text-brand-gold hover:text-brand-white transition-colors flex items-center gap-2 font-medium" data-id="element-571" data-mp="2eceipq9yrfnw">
            <ArrowLeft className="w-4 h-4" data-id="element-572" data-mp="25jus9d3tshe5" />
            Volver al inicio
          </Link>
        </div>
      </nav>

      <main className="flex-grow flex items-center justify-center p-6" data-id="element-573" data-mp="2t9p01g9affrj">
        <div className="max-w-4xl mx-auto w-full" data-id="element-574" data-mp="2t7kpwgkspkit">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-center mb-16" data-id="element-575" data-mp="2y172k8qyloem">
            <div className="inline-block px-4 py-1 rounded-full border border-brand-gold/30 text-brand-gold text-sm font-medium mb-6" data-id="element-576" data-mp="1an574ykdlzr7">
              2% MENSUAL · 24% ANUAL EN DÓLARES
            </div>
            <h1 className="font-heading text-6xl md:text-8xl text-brand-white mb-4" data-id="element-577" data-mp="1jntl5t9rs043">
              TU CAPITAL EN <span className="text-brand-gold" data-id="element-578" data-mp="1ygdp2w4qubml">MOVIMIENTO</span>
            </h1>
            <p className="text-xl text-brand-white/70 max-w-2xl mx-auto" data-id="element-579" data-mp="1tf6gwvyovafe">
              Sumate a la red de inversores de Flash & Go y generá ingresos
              pasivos en dólares desde el primer mes.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-580" data-mp="d0oc5zz47y8m">
            {[{
            icon: DollarSign,
            title: 'Desde U$S 10.000',
            desc: 'Inversión mínima accesible para comenzar a generar retornos.'
          }, {
            icon: TrendingUp,
            title: '2% mensual',
            desc: 'Rentabilidad fija en dólares (24% anual), superando opciones tradicionales.'
          }, {
            icon: Shield,
            title: 'Pagos Mensuales',
            desc: 'Cobrá tus intereses mes a mes sin demoras ni complicaciones.'
          }].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: i * 0.1 + 0.2
          }} className="bg-[#111] border border-brand-gold/20 p-8 rounded-lg text-center hover:border-brand-gold/50 transition-colors" data-id="element-581" data-mp="2w1s0wwlil17q" data-mpi={i}>
                <div className="w-12 h-12 rounded-full bg-brand-gold/10 flex items-center justify-center mx-auto mb-6" data-id="element-582" data-mp="135z7zyn1kd68">
                  <item.icon className="w-6 h-6 text-brand-gold" data-id="element-583" data-mp="y5bixiidi6en" />
                </div>
                <h3 className="font-heading text-2xl text-brand-white mb-3" data-id="element-584" data-mp="u3zqz6c1193a">
                  {item.title}
                </h3>
                <p className="text-brand-white/60 text-sm" data-id="element-585" data-mp="p79aihwb8bhc">{item.desc}</p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.6
        }} className="bg-[#111] border border-brand-gold/30 p-8 md:p-12 rounded-xl text-center" data-id="element-586" data-mp="1lxs2xylo88gl">
            <h2 className="font-heading text-4xl text-brand-white mb-4" data-id="element-587" data-mp="25kg9x9msi7uw">
              ¿Listo para invertir?
            </h2>
            <p className="text-brand-white/70 mb-8 max-w-xl mx-auto" data-id="element-588" data-mp="20s6ljy1bpfuq">
              Dejanos tus datos y un asesor financiero se comunicará con vos
              para explicarte el modelo de negocio en detalle.
            </p>
            <a href="https://project-flash-and-go-investor-landing-page-109.magicpatterns.app" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 bg-brand-gold text-brand-black font-bold rounded hover:bg-brand-white transition-colors" data-id="element-589" data-mp="1pe3ecqvj3gxp">
              CONTACTAR A UN ASESOR
            </a>
          </motion.div>
        </div>
      </main>
    </div>;
}